import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateRangeDuration',
})
export class DateRangeDurationPipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}

  transform(startDate: Date, endDate: Date): string {
    if (startDate && endDate) {
      // prettier-ignore
      return $localize`:@@dpr.dateRangeDurationPipe.txtFullDateRange:Created: ${this.formatDate(startDate)}:startDate: - ${this.formatDate(endDate)}:endDate:`;
    }

    if (startDate) {
      // prettier-ignore
      return $localize`:@@dpr.dateRangeDurationPipe.txtStartOnlyDateRange:Created: From ${this.formatDate(startDate)}:startDate:`;
    }

    if (endDate) {
      // prettier-ignore
      return $localize`:@@dpr.dateRangeDurationPipe.txtEndOnlyDateRange:Created: Until ${this.formatDate(endDate)}:endDate:`;
    }

    return $localize`:@@dpr.dateRangeDurationPipe.txtNoDateRange:Created: All time`;
  }

  private formatDate(date: Date): string {
    return this.datePipe.transform(date, 'mediumDate');
  }
}
